import { allPhotos } from "./allPhotos";

export const weddingPhotos = allPhotos.filter(function(obj) { return obj.type.startsWith('Casamento'); });